module.exports = __webpack_public_path__ + "img/09_Trennseite_ Faltschieben@2x.9d528c20.jpg";